import React from 'react';
import { Box } from '@material-ui/core';
import {
  IVGetCombinedComments_vm_application_comments as ApplicationCommentType,
  IVGetCombinedComments_vm_profile_comments as ProfileCommentType,
} from '../incoming-volunteer/__generated__/IVGetCombinedComments';
import { useSaveComment } from '../../../../common/comment/Comment';
import { CommentBox, PostCommentType } from '../../../../common/comment/CommentBox';
import { CommentViewer } from '../../../../common/comment/CommentViewer';

interface CommentsListProps {
  applicationId: string;
  profileId: string;
  applicationComments: Array<ApplicationCommentType>;
  profileComments: Array<ProfileCommentType>;
  refetch: () => void;
  dialogOpen: boolean;
  dialogClose: () => void;
}

export function ProfileCommentsList({
  profileId,
  applicationComments,
  profileComments,
  refetch,
  dialogOpen,
  dialogClose,
}: CommentsListProps) {
  const saveComment = useSaveComment();

  React.useEffect(() => {
    const timer = setInterval(() => {
      refetch();
    }, 15000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const handleEdit = (body: PostCommentType) => {
    saveComment({
      ...body,
    }).then(() => {
      // onClear();
      if (refetch) {
        refetch();
      }
    });
  };

  const onReply = (parentId: string, content: string) => {
    saveComment({
      parentId,
      profileId: profileId,
      content,
    }).then(() => {
      if (refetch) {
        refetch();
      }
    });
  };

  const onPost = (body: PostCommentType) => {
    saveComment({
      profileId: profileId,
      ...body,
    }).then(() => {
      // onClear();
      if (refetch) {
        dialogClose();
        refetch();
      }
    });
  };

  const profileCommentsFiltered = profileComments.map((item) => ({
    ...item,
    __typename: 'VOLUNTEER_ApplicationCommentType',
    category: 'General',
  }));

  const applicationCommentsFiltered = applicationComments.map((item) => ({
    ...item,
    __typename: 'VOLUNTEER_ApplicationCommentType',
    category: 'Application',
  }));

  const combined = applicationCommentsFiltered
    .concat(profileCommentsFiltered)
    .sort((a, b) => (a.submittedDate > b.submittedDate ? -1 : 1));

  const rootComments = combined?.filter((comment) => !comment.parentId);
  const nonRootComments = combined?.filter((comment) => Boolean(comment.parentId));
  return (
    <Box style={{ backgroundColor: '#f9f9f9' }}>
      {dialogOpen && (
        <Box style={{ backgroundColor: '#fff', margin: '1em', padding: '1.5em 1.5em' }}>
          <CommentBox onPost={onPost} />
        </Box>
      )}
      {rootComments?.map(
        (comment) =>
          !comment.removedDate && (
            <Box style={{ backgroundColor: 'white', margin: '1em', padding: '.5em 1.5em', borderRadius: '5px' }}>
              <CommentViewer
                comment={comment}
                comments={nonRootComments}
                onReply={onReply}
                refetch={refetch}
                handleEdit={handleEdit}
              />
            </Box>
          )
      )}
    </Box>
  );
}
